import { Component, OnDestroy, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { SubSink } from "subsink";
import { NbcLoggerService } from "../../../shared/logger/nbc-logger.service";
import { TemplateService } from "../../../shared/services/template.service";
import * as _ from "lodash";
import { TimesheetService } from "../../../shared/services/timesheet.service";

@Component({
    selector: "create-timesheet-model",
    templateUrl: "./modal-create-timesheet.component.html",
    standalone: false
})
export class ModalCreateTimesheetComponent implements OnInit, OnDestroy {
    constructor(
        public bsModalRef: BsModalRef,
        private templateService: TemplateService,
        private timesheetService: TimesheetService,
        private log: NbcLoggerService
    ) {}

    public onSync!: Subject<any>;
    private sub = new SubSink();
    templates: any;
    modalTitle = "Create Timesheet";
    buAccess: any = {};
    submitted = false;
    queryContainer_: any;
    copyTimesheetSetting: any = {
        name: null,
        templateId: null,
        contactOnly: false,
        contactTimecardOnly: false,
        dayType: false,
        eventShow: false,
        sport: false,
        network: false,
        rate: false,
        companyCode: false,
        wbseCostCenter: false,
        glAccount: false,
        employeeType: false,
        workState: false,
        hoursWorked: false,
        all: false,
    };

    fieldToCopy: any = null;
    showErrormsg = false;
    errorMsg = "";
    defaultOrderBy = "name";
    name: any = "";
    isFormSubmitted = false;

    copyField(fieldToCopy) {
        if (fieldToCopy === "contactOnly") {
            this.copyTimesheetSetting.contactOnly = true;
            this.copyTimesheetSetting.contactTimecardOnly = false;
        } else if (fieldToCopy === "contactTimecardOnly") {
            this.copyTimesheetSetting.contactTimecardOnly = true;
            this.copyTimesheetSetting.contactOnly = false;
        }
    }

    getQueryContainer_() {
        return {
            query: this.templateService.getTemplateListQuery(
                this.buAccess.businessUnitId,
                null,
                999,
                null
            ),
        };
    }

    //queryContainer = {
    //    query: this.timesheetService.getTimesheetSummaryQuery(),
    //};

    cancel() {
        this.log.trace("canceled modal");
        this.bsModalRef.hide();
    }

    OperationChecked() {
        this.copyTimesheetSetting.all = !this.copyTimesheetSetting.all;

        this.copyTimesheetSetting.dayType = this.copyTimesheetSetting.all;
        this.copyTimesheetSetting.eventShow = this.copyTimesheetSetting.all;
        this.copyTimesheetSetting.sport = this.copyTimesheetSetting.all;
        this.copyTimesheetSetting.network = this.copyTimesheetSetting.all;
        this.copyTimesheetSetting.workState = this.copyTimesheetSetting.all;
        this.copyTimesheetSetting.companyCode = this.copyTimesheetSetting.all;
        this.copyTimesheetSetting.rate = this.copyTimesheetSetting.all;
        this.copyTimesheetSetting.wbseCostCenter =
            this.copyTimesheetSetting.all;
        this.copyTimesheetSetting.glAccount = this.copyTimesheetSetting.all;
        this.copyTimesheetSetting.employeeType = this.copyTimesheetSetting.all;
        this.copyTimesheetSetting.hoursWorked = this.copyTimesheetSetting.all;
    }

    optionToggled() {
        this.copyTimesheetSetting.all =
            this.copyTimesheetSetting.dayType &&
            this.copyTimesheetSetting.eventShow &&
            this.copyTimesheetSetting.sport &&
            this.copyTimesheetSetting.network &&
            this.copyTimesheetSetting.workState &&
            this.copyTimesheetSetting.companyCode &&
            this.copyTimesheetSetting.rate &&
            this.copyTimesheetSetting.wbseCostCenter &&
            this.copyTimesheetSetting.glAccount &&
            this.copyTimesheetSetting.employeeType &&
            this.copyTimesheetSetting.hoursWorked;
    }

    validate() {
        if (_.trim(this.name).length <= 0) {
            return false;
        }
        return true;
    }

    getTimesheetTemplates() {
        this.log.trace("Get Timesheet Template");
        this.queryContainer_.query.sortByColumn = this.defaultOrderBy;
        this.queryContainer_.query.isActive = "Y";
        this.sub.sink = this.templateService
            .getTemplates(this.queryContainer_.query)
            .subscribe({
                next: (result) => {
                    this.templates = result.reference.items;
                    this.copyTimesheetSetting.templateId = this.templates.id;
                },
                error: (err) => {
                    this.log.error(err);
                    this.log.showModalError(
                        "Unable to load the timesheet template at this time. Please try again later."
                    );
                },
            });
    }

    createTimesheet(form) {
        //self.submitted = true;
        this.log.trace("Creating Timesheet");
        if (form.valid) {
            if (!this.copyTimesheetSetting.templateId) {
                this.copyTimesheetSetting.contactOnly = false;
                this.copyTimesheetSetting.contactTimecardOnly = false;
            }
            this.copyTimesheetSetting.businessUnitId =
                this.buAccess.businessUnitId;
            this.copyTimesheetSetting.departmentId = this.buAccess.departmentId;
            this.copyTimesheetSetting.templateId = this.copyTimesheetSetting
                .templateId
                ? this.copyTimesheetSetting.templateId.id
                : "";

            this.timesheetService.create(this.copyTimesheetSetting).subscribe({
                next: (result: any) => {
                    // usSpinnerService.spin("searchSpinner");
                    this.log.trace("got results: " + JSON.stringify(result));
                    this.onSync.next({ timesheetBatch: result });
                    this.bsModalRef.hide();

                    // $modalInstance.close({ timesheetBatch: result });
                },
                error: (data) => {
                    this.log.error("got an error: " + JSON.stringify(data));
                    // $scope.$emit("showAlert", "danger", "Unable to create the timesheet batch at this time. Please try again later.", "modalAlert");
                    this.log.showError(
                        "Unable to create the timesheet batch at this time. Please try again later."
                    );
                    this.isFormSubmitted = false;
                },
            });
            //else {
            //  $scope.$emit("showAlert", "danger", "Form is invalid.", "modalAlert");
            //}
        }
    }

    CheckValidation(isValid, submitted) {
        if (isValid == "VALID") {
            return false;
        } else {
            return true;
        }
    }

    validateName(form) {
        this.isFormSubmitted = true;
        if (this.copyTimesheetSetting.name) {
            this.queryContainer_.query.businessUnitId =
                this.buAccess.businessUnitId;
            this.queryContainer_.query.timesheetName =
                this.copyTimesheetSetting.name;
            this.queryContainer_.query.departmentId =
                this.buAccess.departmentId;
            this.timesheetService
                .validateName(this.queryContainer_.query)
                .subscribe({
                    next: (result: any) => {
                        this.log.trace(
                            "got results: " + JSON.stringify(result)
                        );
                        if (!result) {
                            this.log.showError(
                                "Timesheet Name already exists, please enter a unique name."
                            );
                            // form.controls["name"].setErrors({
                            //     required: false,
                            // });
                            this.isFormSubmitted = false;
                        } else {
                            if (
                                _.isEmpty(this.fieldToCopy) &&
                                this.copyTimesheetSetting.templateId
                            ) {
                                //$scope.$emit("showAlert", "danger", "Fields to Copy is required.", "modalAlert");
                                this.log.showError(
                                    "Fields to Copy is required"
                                );
                                // form.controls["name"].setErrors({
                                //     required: false,
                                // });
                                this.isFormSubmitted = false;
                            } else {
                                form.controls["name"].setErrors(null);
                                this.isFormSubmitted = true;
                                this.createTimesheet(form);
                            }
                        }
                    },
                    error: (data) => {
                        this.log.error("got an error: " + JSON.stringify(data));
                        this.log.showError(
                            "Unable to create the timesheet batch at this time. Please try again later."
                        );
                        this.isFormSubmitted = false;
                    },
                });
        }
    }

    ngOnInit() {
        this.onSync = new Subject();
        //this.templates = this.templates;
        this.buAccess = _.get(this, "userBuAccess");
        this.queryContainer_ = this.getQueryContainer_();
        this.getTimesheetTemplates();
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
